module.exports = __webpack_public_path__ + "img/smoke.badd9ef2.png";